import { MainComponent } from './pages/main/main.component'
import { KeyingAuthService } from './services/keying.auth.service'
import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { CallbackComponent } from './pages/callback/callback.component'
import { KeySystemComponent } from './pages/key-system/key-system.component'
import { DashboardComponent } from './pages/key-system/dashboard/dashboard.component'
import { HierarchyComponent } from './pages/key-system/hierarchy/hierarchy.component'
import { FindKeySystemComponent } from './pages/main/find-key-system/find-key-system.component'
import { NewKeySystemComponent } from './pages/main/new-key-system/new-key-system.component'
import { AppRoutingConfig } from './configuration/app.routing.config'
import { HistoryPageComponent } from './pages/key-system/history.page/history.page.component'
import { BudgetComponent } from './pages/key-system/budget/budget.component'
import { DealerMasterKeyComponent } from './pages/key-system/dealer-masterkey/dealer-masterkey.component'
import { RegistryNumberComponent } from './pages/key-system/registry-number/registry-number.component'
import { StructureComponent } from './pages/structure/structure.component'
import { IndependentKeySystemsComponent } from './pages/structure/independent-key-systems/independent-key-systems.component'
import { HistoryStructurePageComponent } from './pages/structure/history.structure.page/history.structure.page.component'
import { ReportsComponent } from './pages/key-system/reports/reports.component'
import { OrderDetailComponent } from './pages/key-system/order-detail/order-detail.component'
import { ToolsComponent } from './pages/key-system/tools/tools.component'
import { UnsavedChangesGuard } from './guards/unsavedChangesGuard'
import { SuperUserGuard } from './guards/super-user.guard'

const routes: Routes = [
  {
    path: AppRoutingConfig.emptyUrl,
    component: MainComponent,
    canActivate: [KeyingAuthService],
    children: [
      {
        path: AppRoutingConfig.emptyUrl,
        component: FindKeySystemComponent,
      },
      {
        path: AppRoutingConfig.structuresUrl,
        component: FindKeySystemComponent,
      },
      {
        path: AppRoutingConfig.newStructureUrl,
        component: NewKeySystemComponent,
      },
    ],
  },
  {
    path: AppRoutingConfig.structureNew.url,
    component: StructureComponent,
    canActivate: [KeyingAuthService],
    children: [
      {
        path: AppRoutingConfig.emptyUrl,
        component: IndependentKeySystemsComponent,
      },
      {
        path: AppRoutingConfig.structureNewKeySystems.path,
        component: IndependentKeySystemsComponent,
      },
      {
        path: AppRoutingConfig.structureHistory.path,
        component: HistoryStructurePageComponent,
      },
    ],
  },
  {
    path: AppRoutingConfig.structure.url,
    component: KeySystemComponent,
    canActivate: [KeyingAuthService],
    children: [
      {
        path: AppRoutingConfig.emptyUrl,
        component: DashboardComponent,
      },
      {
        path: AppRoutingConfig.structureBudget.path,
        component: BudgetComponent,
      },
      {
        path: AppRoutingConfig.structureHierarchy.path,
        component: HierarchyComponent,
      },
      {
        path: AppRoutingConfig.keySystemReports.path,
        component: ReportsComponent,
      },
      // {
      //   path: AppRoutingConfig.structureHistory.path,
      //   component: HistoryPageComponent,
      // },
      {
        path: AppRoutingConfig.structureOrderDetails.path,
        component: OrderDetailComponent,
      },
      {
        path: AppRoutingConfig.keySystemRegistryNumbers.path,
        component: RegistryNumberComponent,
      },
      {
        path: AppRoutingConfig.keySystemTools.path,
        component: ToolsComponent,
      },
      {
        path: AppRoutingConfig.dealerMasterKey.path,
        component: DealerMasterKeyComponent,
        canDeactivate: [UnsavedChangesGuard],
      },
    ],
  },
  {
    path: 'feature-management',
    canActivate: [KeyingAuthService, SuperUserGuard],
    loadChildren: () =>
      import('@overtur-monorepo/feature-management').then((m) => m.FeatureManagementModule),
  },
  {
    path: 'notification-management',
    canActivate: [KeyingAuthService],
    loadChildren: () =>
      import('@overtur-monorepo/notification-management').then((m) => m.NotificationManagementModule),
  },
  { path: AppRoutingConfig.callbackUrl, component: CallbackComponent },
  { path: AppRoutingConfig.logoutUrl, redirectTo: AppRoutingConfig.emptyUrl },
  {
    path: AppRoutingConfig.otherUrl,
    redirectTo: AppRoutingConfig.structuresUrl,
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
